import { render, staticRenderFns } from "./bshare.vue?vue&type=template&id=637e1372"
import script from "./bshare.vue?vue&type=script&lang=js"
export * from "./bshare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports